import React from 'react';
import '../styles/App.css';
import Sidebar from '../components/sidemenu/sidebar';
import CrudTable from '../components/cruds/crud_COMPANIAS';

const companias = () => {
  return (
    <div>
        <Sidebar/>
        <div>
            <h3 className="title">Gestión Compañías</h3>
        </div>
        <CrudTable/>
    </div>
  );


};

export default companias;